/** @ngInject */
export class ConfirmationModalBean {
    constructor(message, pageTitle) {
        this.message = message;
        this.pageTitle = pageTitle;
    }
}
